module.exports = __webpack_public_path__ + "img/Library-rafiki.a644c433.svg";